import {useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {getDateFormat} from '../../../library/dates';
import {DEFAULT_TIME_ZONE} from '../../../globalVariables/locals';
import TicketRow from './TicketRow';
import {SubtitleContainer} from './TicketSelection.css';

interface TicketSelectionProps {
    ticketsQr: any[];
    onTicketsChange: (tickets: any[]) => void;
}

function TicketSelection({ticketsQr, onTicketsChange}: TicketSelectionProps) {
    const {t} = useTranslation('suspendedConfirmation');

    const processedTicketsQr = useMemo(() => {
        if(!ticketsQr) return [];

        return ticketsQr.map(item => {
            const processedItem = {
                ...item,
                title: item.title || '',
                description: ''
            };

            switch (item.type) {
                case 'ticket':
                    processedItem.description = '';
                    break;
                case 'ticket_price':
                    processedItem.description = getDateFormat(item.date, 'YYYY-MM-DD HH:mm', DEFAULT_TIME_ZONE) || '';
                    break;
                case 'extra':
                    processedItem.title = t('extra');
                    processedItem.description = item.title || '';
                    break;
                case 'seat':
                    processedItem.description = `${t('seat')} ${item.x} ${t('row')} ${item.y}`;
                    break;
            }

            return processedItem;
        });
    }, [ticketsQr, t]);

    const [selectedTickets, setSelectedTickets] = useState<Array<any>>(
        processedTicketsQr || []
    );

    const handleTicketClick = (qid: string, action?: 'approve' | 'reject') => {
        let newSelectedTickets;

        if(action === 'approve') {
            newSelectedTickets = [...selectedTickets, processedTicketsQr.find(t => t.qid === qid)];
        } else if(action === 'reject') {
            newSelectedTickets = selectedTickets.filter((t) => t.qid !== qid);
        } else {
            // No action - do nothing
            return;
        }

        setSelectedTickets(newSelectedTickets);
        onTicketsChange(newSelectedTickets);
    };

    return (
        <>
            <SubtitleContainer>
                {t('ticketConfirmationSubtitle')}
            </SubtitleContainer>

            {processedTicketsQr.map((ticket) => (
                <TicketRow
                    key={ticket.qid}
                    title={ticket.title}
                    description={ticket.description}
                    price={ticket.price}
                    selected={selectedTickets.some(t => t.qid === ticket.qid)}
                    onClick={(action) => handleTicketClick(ticket.qid, action)}
                />
            ))}
        </>
    );
}

export default TicketSelection;
